import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "latest-activity"
};
const _hoisted_2 = {
  class: "swiper-box"
};
const _hoisted_3 = {
  class: "activity-item"
};
const _hoisted_4 = {
  class: "item-title"
};
const _hoisted_5 = {
  class: "item-info"
};
const _hoisted_6 = ["title"];
const _hoisted_7 = {
  class: "item-info"
};
const _hoisted_8 = {
  class: "info-value"
};
const _hoisted_9 = {
  class: "item-info"
};
const _hoisted_10 = {
  class: "info-value"
};
const _hoisted_11 = {
  class: "item-time"
};
const _hoisted_12 = {
  class: "time-value"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide");
  const _component_Swiper = _resolveComponent("Swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "title"
  }, [_createElementVNode("img", {
    src: "https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202506/0dcca555b2af488ab56f19c5611f44b6.png"
  })], -1)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_Swiper, {
    watchSlidesProgress: true,
    slidesPerView: "3",
    spaceBetween: 24,
    navigation: {
      nextEl: '.custom-next',
      prevEl: '.custom-prev'
    },
    class: "swiper-content"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.activityList, (item, index) => {
      return _openBlock(), _createBlock(_component_SwiperSlide, {
        class: "swiper-slide",
        key: item.id
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.activity_name), 1), _createElementVNode("div", _hoisted_5, [_cache[0] || (_cache[0] = _createElementVNode("span", {
          class: "info-icon info-unit"
        }, null, -1)), _cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "info-label"
        }, "发起单位：", -1)), _createElementVNode("span", {
          class: "info-value",
          title: item.organizer
        }, _toDisplayString(item.organizer), 9, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("span", {
          class: "info-icon info-time"
        }, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("span", {
          class: "info-label"
        }, "开始时间：", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(item.start_time), 1)]), _createElementVNode("div", _hoisted_9, [_cache[4] || (_cache[4] = _createElementVNode("span", {
          class: "info-icon info-time"
        }, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("span", {
          class: "info-label"
        }, "结束时间：", -1)), _createElementVNode("span", _hoisted_10, _toDisplayString(item.end_time), 1)]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString($options.showDay(item.end_time)), 1), _cache[6] || (_cache[6] = _createElementVNode("span", null, "天", -1))]), _cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "time-label"
        }, "剩余时间", -1))])])]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "custom-nav"
  }, [_createElementVNode("button", {
    class: "custom-prev"
  }), _createElementVNode("button", {
    class: "custom-next"
  })], -1))])]);
}